import React from 'react';
import './MarathiTable.css';

// Static Marathi dairy/milk-collection table data
const baseData = [
    { id: 1, farmer: 'रामराव पाटील', center: 'केंद्र अ', session: 'सकाळ', liters: 12.5, fat: 3.8, snf: 8.2, rate: 28, amount: 350 },
    { id: 2, farmer: 'सुनीता देशमुख', center: 'केंद्र ब', session: 'संध्याकाळ', liters: 8.0, fat: 4.1, snf: 8.5, rate: 30, amount: 240 },
    { id: 3, farmer: 'विजय जाधव', center: 'केंद्र अ', session: 'सकाळ', liters: 15.2, fat: 3.6, snf: 7.9, rate: 27, amount: 410 },
    { id: 4, farmer: 'कविता शिंदे', center: 'केंद्र क', session: 'संध्याकाळ', liters: 6.5, fat: 4.4, snf: 8.8, rate: 32, amount: 208 },
    { id: 5, farmer: 'महेश भोसले', center: 'केंद्र ब', session: 'सकाळ', liters: 20.0, fat: 3.5, snf: 7.8, rate: 26, amount: 520 },
    { id: 6, farmer: 'सावित्री मोरे', center: 'केंद्र अ', session: 'संध्याकाळ', liters: 9.8, fat: 4.2, snf: 8.6, rate: 31, amount: 304 },
    { id: 7, farmer: 'प्रकाश कदम', center: 'केंद्र क', session: 'सकाळ', liters: 11.4, fat: 3.9, snf: 8.3, rate: 29, amount: 331 },
    { id: 8, farmer: 'लता सालुंखे', center: 'केंद्र ब', session: 'संध्याकाळ', liters: 14.0, fat: 4.0, snf: 8.4, rate: 30, amount: 420 },
    { id: 9, farmer: 'दिनेश वाघमारे', center: 'केंद्र अ', session: 'सकाळ', liters: 7.5, fat: 3.7, snf: 8.0, rate: 28, amount: 210 },
    { id: 10, farmer: 'पूजा गायकवाड', center: 'केंद्र क', session: 'संध्याकाळ', liters: 18.3, fat: 4.3, snf: 8.7, rate: 32, amount: 586 },
    { id: 11, farmer: 'संजय पवार', center: 'केंद्र ब', session: 'सकाळ', liters: 10.0, fat: 3.8, snf: 8.1, rate: 28, amount: 280 },
    { id: 12, farmer: 'अनिता कुलकर्णी', center: 'केंद्र अ', session: 'संध्याकाळ', liters: 5.5, fat: 4.5, snf: 8.9, rate: 33, amount: 182 },
    { id: 13, farmer: 'बाळासाहेब निकम', center: 'केंद्र क', session: 'सकाळ', liters: 22.0, fat: 3.4, snf: 7.7, rate: 25, amount: 550 },
    { id: 14, farmer: 'मंगल खोमणे', center: 'केंद्र ब', session: 'संध्याकाळ', liters: 13.5, fat: 4.1, snf: 8.5, rate: 30, amount: 405 },
    { id: 15, farmer: 'राजू थोरात', center: 'केंद्र अ', session: 'सकाळ', liters: 16.8, fat: 3.6, snf: 8.0, rate: 27, amount: 454 },
];

const tableData = Array.from({ length: 120 }, (_, i) => ({
    ...baseData[i % baseData.length],
    id: i + 1
}));

const totalLiters = tableData.reduce((s, r) => s + r.liters, 0).toFixed(1);
const totalAmount = tableData.reduce((s, r) => s + r.amount, 0);
const avgFat = (tableData.reduce((s, r) => s + r.fat, 0) / tableData.length).toFixed(2);
const avgSnf = (tableData.reduce((s, r) => s + r.snf, 0) / tableData.length).toFixed(2);

function MarathiTable() {
    return (
        <div className="marathi-table-wrapper">
            <table className="marathi-table">
                <thead>
                    <tr>
                        <th>अ.क्र.</th>
                        <th>शेतकरी नाव</th>
                        <th>केंद्र</th>
                        <th>सत्र</th>
                        <th>दूध (लिटर)</th>
                        <th>फॅट (%)</th>
                        <th>SNF (%)</th>
                        <th>दर (₹/ली.)</th>
                        <th>रक्कम (₹)</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((row) => (
                        <tr key={row.id}>
                            <td>{row.id}</td>
                            <td className="name-col">{row.farmer}</td>
                            <td>{row.center}</td>
                            <td>
                                <span className={`session-badge ${row.session === 'सकाळ' ? 'morning' : 'evening'}`}>
                                    {row.session}
                                </span>
                            </td>
                            <td>{row.liters.toFixed(1)}</td>
                            <td>{row.fat.toFixed(1)}</td>
                            <td>{row.snf.toFixed(1)}</td>
                            <td>₹{row.rate}</td>
                            <td className="amount-col">₹{row.amount}</td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr className="totals-row">
                        <td colSpan={4}><strong>एकूण / सरासरी</strong></td>
                        <td><strong>{totalLiters}</strong></td>
                        <td><strong>{avgFat}</strong></td>
                        <td><strong>{avgSnf}</strong></td>
                        <td>—</td>
                        <td><strong>₹{totalAmount}</strong></td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
}

export default MarathiTable;
